import { InputCommaSepreatedPipe } from "./input-comma-sepreated.pipe";
import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[appInputCommaSepreated]",
})
export class InputCommaSepreatedDirective {
  constructor(private formatPipe: InputCommaSepreatedPipe) {}
  @HostListener("focusout", ["$event"])
  onFocus(event: FocusEvent) {
    let input = event.target as HTMLInputElement;
    let number = parseFloat(input.value.replace(/,/g, ""));
    if (isNaN(number) || number <= 0) {
      input.value = "";
    } else {
      input.value = this.formatPipe.transform(number).toString();
    }
  }
}
